module.exports = __webpack_public_path__ + "img/2f71a1a.png";